import React from 'react';
import NotComeOut from '../common/not-come-out/NotComeOut';
import PreRender from '../common/PreRender';

const Order = props => {
  return (
    <PreRender {...props}>
      <NotComeOut />
    </PreRender>
  );
};

export default Order;
